/**
 * Skupina z Objedname — společná pro seznam i pro obrazovku.
 *
 * Vlastní soubor, ne konstanta v jedné z komponent: seznam i obal ji
 * potřebují a import jednoho z druhého by udělal kruh.
 *
 * Objedname combo nezná a obchází ho přes přídavky, takže skupina
 * („Nápoj výhodně", „Příloha výhodně", „Vyberte si svou pizzu") je
 * jediné místo, kde je ta struktura vidět.
 */

/** Název pro položky, které v Objedname žádnou skupinu nemají. */
export const BEZ_SKUPINY = '— bez skupiny —';

export const doSkupiny = (p) => p.skupina_obj || BEZ_SKUPINY;
